export default __webpack_public_path__ + "static/media/choose-instagram-fr.b9932ff1.png";